import React from 'react';
import { useTranslation } from 'react-i18next';

interface IconButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  className?: string;
}

function base(variant: 'danger' | 'default') {
  return `p-1.5 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-40 disabled:cursor-not-allowed ${
    variant === 'danger'
      ? 'text-gray-400 hover:text-red-600 hover:bg-red-50 focus:ring-red-400'
      : 'text-gray-400 hover:text-primary-600 hover:bg-primary-50 focus:ring-primary-400'
  }`;
}

export function PencilButton({ onClick, disabled, title, className = '' }: IconButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title ?? t('admin.editButton')}
      className={`${base('default')} ${className}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6.586-6.586a2 2 0 112.828 2.828L11.828 15.828A2 2 0 0110 16.414H8v-2a2 2 0 01.586-1.414z" />
      </svg>
    </button>
  );
}

export function TrashButton({ onClick, disabled, title, className = '' }: IconButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title ?? t('admin.deleteLeague')}
      className={`${base('danger')} ${className}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m-7 0a1 1 0 01-1-1V5a1 1 0 011-1h6a1 1 0 011 1v1a1 1 0 01-1 1H9z" />
      </svg>
    </button>
  );
}
